<template>
  <div>
    <!-- Label -->
    <label v-if="label" :for="name" class="inputLabel">
      {{ label }}
      <span v-if="required" class="requiredStar">*</span>
    </label>

    <!-- Select Input -->
    <div class="customSelectWrapper">
      <div
        class="customSelect"
        :class="selectClasses"
        @click.self="openSelect()"
        v-click-outside="closeSelect"
        ref="container"
        @keydown="navList"
        tabindex="0"
      >
        <div
          class="customSelectValue"
          :id="id"
          @click.self="openSelect()"
          tabindex="0"
        >
          <span
            :class="computedSelectedOption.value === '' ? 'optionDefault' : ''"
            @click.self="openSelect()"
          >
            {{ computedSelectedOption.name }}
          </span>
          <i
            class="fa fa-caret-down selectArrow"
            @click.self="openSelect()"
          ></i>
        </div>
        <div class="customSelectOptions" :id="'customSelectOptions' + id">
          <div :class="checkLength ? 'needsBorder' : ''">
            <ul class="fixed-wrapper">
              <li
                class="customOptionSearch"
                :class="filteredOptions.length ? 'marginFix' : ''"
                v-if="showSearchSelect"
              >
                <input
                  class="block w-full sm:text-sm rounded-md"
                  type="search"
                  :id="id + 'inputSearch'"
                  v-model="inputFilter"
                  autocomplete="new-password"
                  :placeholder="'Search for a ' + label.toLowerCase()"
                />
              </li>
            </ul>
            <ul>
              <li
                class="customOption optionDefault"
                :class="computedSelectedOption.value === '' ? 'selected' : ''"
                @click="handleSelect({ name: selectPlaceholder, value: '' })"
                v-if="showDefaultOption && !required && !showSearchSelect"
              >
                {{ selectPlaceholder }}
              </li>

              <li
                class="customOption"
                :id="`select${index}`"
                v-for="(option, index) in filteredOptions"
                :key="index"
                @click="handleSelect(option)"
              >
                {{ option.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'Select',
  data() {
    return {
      touched: false,
      error: false,
      errorText: this.label + ' is required',
      success: false,
      selectOpen: false,
      selectedOption: {
        name: 'Select an option',
        value: 'default',
      },
      inputFilter: '',
      currentItem: -1,
    };
  },
  directives: {
    ClickOutside,
  },
  mounted() {
    if (this.placeholder !== '') {
      this.selectedOption.name = this.placeholder;
    } else {
      this.selectedOption.name = 'Select an option';
    }
  },
  watch: {
    selected: function(val) {
      if (!val || val === 'default' || val === '') {
        this.selectedOption = {
          name: this.placeholder,
          value: 'default',
        };
      } else {
        if (
          this.options.some(
            option =>
              option.name === this.selected ||
              option.value === this.selected ||
              option.id === this.selected
          )
        ) {
          this.selectedOption = this.options.find(
            option =>
              option.name === this.selected ||
              option.value === this.selected ||
              option.id === this.selected
          );
        }
      }
    },
  },
  computed: {
    filteredOptions() {
      if (this.inputFilter !== '') {
        return this.options.filter(option =>
          option.name.toLowerCase().includes(this.inputFilter.toLowerCase())
        );
      }
      return this.options;
    },
    computedSelectedOption() {
      if (this.options.some(option => option.value === this.selected)) {
        return this.options.find(option => option.value === this.selected);
      }
      if (this.options.some(option => option.id === this.selected)) {
        return this.options.find(option => option.id === this.selected);
      }
      return this.selectedOption;
    },
    selectClasses() {
      let classes = [];
      if (this.disabled) {
        classes.push('disabled');
      }
      if (this.selectOpen) {
        classes.push('open');
      }
      if (this.error && this.touched && this.required) {
        classes.push('inputError');
      }
      return classes;
    },
    selectPlaceholder() {
      return this.placeholder !== '' ? this.placeholder : 'Select an option';
    },
    checkLength() {
      return this.options.length > 4;
    },
  },
  methods: {
    handleSelect(option) {
      this.touched = true;
      this.selectedOption = option;
      const value = option.value;
      this.inputValueModel = value;
      this.selectOpen = false;
      this.inputFilter = '';

      if (typeof value !== undefined) {
        this.success = true;
        this.error = false;
        this.$emit('error-change', false);
        this.$refs.container.classList.remove('inputError');
        return this.$emit('input-change', {
          key: option.name,
          value: option.value,
        });
      } else {
        this.$emit('error-change', true);
        this.error = true;
        this.success = false;
        return (this.error = 'error');
      }
    },
    navList(event) {
      const options = this.filteredOptions.length
        ? this.filteredOptions
        : this.options;

      if (event.keyCode === 13) {
        this.handleSelect(options[this.currentItem]);
        event.preventDefault();
      }

      if (event.keyCode === 38 && this.currentItem > 0) {
        this.currentItem--;
        event.preventDefault();
      } else if (event.keyCode === 40 && this.currentItem < options.length) {
        this.currentItem++;
        event.preventDefault();
      }
    },
    openSelect() {
      if (!this.disabled) {
        this.selectOpen = !this.selectOpen;
        if (this.selectOpen && this.showSearchSelect) {
          let searchEl = document.getElementById(this.id + 'inputSearch');
          setTimeout(() => {
            searchEl.focus();
          }, 50);
        }
      }
    },
    closeSelect() {
      this.selectOpen = false;
    },
  },

  props: {
    options: {
      type: Array,
      default: null,
    },
    selected: {
      default: 'default',
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    showSearchSelect: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showDefaultOption: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.customSelectTrigger {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 22px;
  font-size: 20px;
  font-weight: 300;
  color: #3b3b3b;
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  border: 1px solid #dadee6;
}

.customSelectOptions {
  position: absolute;
  display: block;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid #c9cccf;
  border-radius: 5px;
  background: #fff;
  transition: all 0.25s;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 3000;
  max-height: 243px;
  overflow-y: auto;

  --scrollbarBG: #fff;
  --thumbBG: rgba(0, 0, 0, 0.15);

  scrollbar-width: thin;
  scrollbar-color: var(--thumbBG) var(--scrollbarBG);
}
.needsBorder {
  border-right: 1px solid #c9cccf;
}
.customSelectOptions::-webkit-scrollbar {
  width: 11px;
}
.customSelectOptions::-webkit-scrollbar-track {
  background: var(--scrollbarBG);
}
.customSelectOptions::-webkit-scrollbar-thumb {
  background-color: var(--thumbBG);
  border-radius: 6px;
  border: 2px solid var(--scrollbarBG);
}

.customSelect.open {
  box-shadow: 0 0 0 2px #3b89ff;
}

.customSelect.open .customSelectOptions {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.customOption {
  cursor: pointer;
  position: relative;
  display: block;
  padding: 8px 16px;
  margin: 0 8px;
  color: #363d4d;
  line-height: 24px;
  border-radius: 5px;
  transition: all 0.25s;
}
.customOption.selected {
  background: #f6f6f7;
}
.customOption:last-child {
  margin-bottom: 8px;
}
.fixed-wrapper {
  width: 100%;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3333;
  margin-bottom: 8px;
}
.customOptionSearch {
  cursor: pointer;
  background: #fff;
  display: block;
  padding: 8px 8px;
  line-height: 20px;
  border-radius: 5px;
  transition: all 0.25s;
  z-index: 3200;
}
.marginFix {
  margin-top: -8px;
}
.customOptionSearch input {
  border: 1px solid #abb0b6;
  font-size: 14px;
  line-height: 20px;
}
.customOptionSearch input::placeholder {
  color: #bababa;
}

.customOption:hover {
  cursor: pointer;
  background-color: #f6f6f7;
}

.optionDefault {
  color: #727a88;
}

.selectArrow {
  float: right;
  text-align: center;
  width: 16px;
  line-height: 20px;
}

.inputError {
  background: #fff4f4;
  border-color: #ff5252 !important;
  &::placeholder {
    color: #202223 !important;
  }
}
.inputError .customSelectValue {
  color: #951a1a !important;
}
.inputErrorText {
  color: #951a1a;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-left: 4px;
}
</style>
